import { LockeClientId, LockeConfig, LOCKE_PRODUCTION_ID } from '../types';

const isLockeProduction = (lockeClientId: LockeClientId): boolean =>
  lockeClientId === LOCKE_PRODUCTION_ID;

export const getLockeConfig = (
  lockeClientId: LockeClientId = LOCKE_PRODUCTION_ID,
): LockeConfig => {
  const isProduction = isLockeProduction(lockeClientId);
  const host = isProduction
    ? 'https://www.realcommercial.com.au'
    : 'https://www.staging.e2e.realcommercial.com.au';
  const redirectUrl = window?.location
    ? `${host}${window.location.pathname}${window.location.search}`
    : `${host}/`;
  const rcaApiHost = isProduction
    ? 'https://api.realcommercial.com.au'
    : 'https://api.staging.e2e.realcommercial.com.au';
  return {
    lockeClientId,
    lockeSettingsUrl: 'https://settings.accounts.realestate.com.au',
    lockeApiUrl: 'https://accounts.realestate.com.au',
    redirectUrl,
    rcaApiHost,
  };
};
